import React from 'react';
import { ModalWindow } from '../static/styles/styles';

const Modal = ({ isOpen, children }) => {
    if (isOpen) {
        return (
            <ModalWindow>{children}</ModalWindow>
        )
    }
    return null
}

export default Modal;


// WEBPACK FOOTER //
// ./src/componenten/Modal.js